import { render, staticRenderFns } from "./editor-wrapper.vue?vue&type=template&id=c47476a6&scoped=true&"
import script from "./editor-wrapper.vue?vue&type=script&lang=js&"
export * from "./editor-wrapper.vue?vue&type=script&lang=js&"
import style0 from "./editor-wrapper.vue?vue&type=style&index=0&id=c47476a6&prod&lang=scss&"
import style1 from "./editor-wrapper.vue?vue&type=style&index=1&id=c47476a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c47476a6",
  null
  
)

export default component.exports